import React from 'react'

const FILL_TOP_VAR = '--fill-top'

// Блок тянется до низа экрана: стили вычитают из высоты экрана его отступ от
// начала страницы. Отступ меряем, а не зашиваем: у продавца над блоком одна
// шапка, у админа ещё заголовок, и оба меняют высоту после первой отрисовки —
// догружаются логотип и имя продавца
export const useViewportFill = (elementRef: React.RefObject<HTMLElement>) => {
  React.useLayoutEffect(() => {
    const element = elementRef.current
    if (!element) return

    let top: number | null = null

    const update = () => {
      const next = Math.round(element.getBoundingClientRect().top + window.scrollY)
      if (next === top) return

      top = next
      element.style.setProperty(FILL_TOP_VAR, `${next}px`)
    }

    update()
    // Сдвинуть блок вниз могут только те, кто стоит перед ним или перед его
    // предками. Body не годится: он упирается в высоту экрана и не меняется
    const observer = new ResizeObserver(update)
    for (let node: Element | null = element; node && node !== document.body; node = node.parentElement) {
      for (let sibling = node.previousElementSibling; sibling; sibling = sibling.previousElementSibling) {
        observer.observe(sibling)
      }
    }
    window.addEventListener('resize', update)

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', update)
    }
  }, [elementRef])
}
